import React from "react";
import { useSlate } from "slate-react";
import { Tooltip } from "../../../Tooltip";

export const UndoButton = () => {
  const editor = useSlate();

  const handleUndo = (event: React.MouseEvent) => {
    event.preventDefault();
    // Access the history operations from the editor which is enhanced with withHistory
    editor.undo();
  };

  return (
    <Tooltip text="Undo">
      <button
        onMouseDown={handleUndo}
        className="h-9 w-9 inline-flex items-center justify-center text-gray-600 hover:bg-gray-100 rounded"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-5 h-5"
        >
          <path d="M3 10h10a5 5 0 0 1 5 5v2a5 5 0 0 1-5 5h-4"></path>
          <path d="M3 10l5-5"></path>
          <path d="M3 10l5 5"></path>
        </svg>
      </button>
    </Tooltip>
  );
};

export const RedoButton = () => {
  const editor = useSlate();

  const handleRedo = (event: React.MouseEvent) => {
    event.preventDefault();
    // Access the history operations from the editor which is enhanced with withHistory
    editor.redo();
  };

  return (
    <Tooltip text="Redo">
      <button
        onMouseDown={handleRedo}
        className="h-9 w-9 inline-flex items-center justify-center text-gray-600 hover:bg-gray-100 rounded"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-5 h-5"
        >
          <path d="M21 10h-10a5 5 0 0 0-5 5v2a5 5 0 0 0 5 5h4"></path>
          <path d="M21 10l-5-5"></path>
          <path d="M21 10l-5 5"></path>
        </svg>
      </button>
    </Tooltip>
  );
};
